import React from "react";
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";

const TabsInfoModal = ({
  data,
  title,
  setInfoModalOpen,
  infoModalOpen,
  subPoints,
}) => {
  const toggleInfoModal = () => setInfoModalOpen(!infoModalOpen);
  return (
    <Modal isOpen={infoModalOpen} toggle={toggleInfoModal}>
      <ModalHeader toggle={toggleInfoModal}>
        <h2 className="text-center">{title}</h2>
      </ModalHeader>
      <ModalBody>
        {subPoints && subPoints.length > 0 && (
          <dl>
            {subPoints?.map((point, index) => (
              <>
                <dt key={index}>{`${point.title}:`}</dt>
                <dd key={index}>{point.description}</dd>
              </>
            ))}
          </dl>
        )}
        <h4 className="mr-auto">Admin Activity</h4>
        <ul>
          {data?.map((point, index) => (
            <li key={index}>{point}</li>
          ))}
        </ul>
      </ModalBody>
      <ModalFooter>
        <Button color="secondary" onClick={toggleInfoModal}>
          Close
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default TabsInfoModal;
